module.exports = __webpack_public_path__ + "img/dku.00104.33ef3198.png";